module.exports = __webpack_public_path__ + "img/1676.26dedcce.gif";